import React, { useState, useEffect } from "react";

import { Link, withRouter } from "react-router-dom";

import Layout from "../../components/Layout";

import api from "../../services/api";

import Swal from "sweetalert2";

const LearnMoreList = (props) => {
	const [learnMoreItems, setLearnMoreItems] = useState([]);
	const [loaded, setLoaded] = useState(false);
	const [searchText, setSearchText] = useState("");
	const [pages, setPages] = useState(0);
	const [actualPage, setActualPage] = useState(1);

	useEffect(function () {
		const load = async () => {
			setLoaded(false);
			await loadItems();
			setLoaded(true);
		};
		load();
	}, []);

	const loadItems = async (page = 1, search = "") => {
		const learnMoreItemsResponse = await api.get(
			`/learn-more?page=${page}${
				search !== "" ? "&title=" + encodeURI(search) : ""
			}`,
		);
		setLearnMoreItems(learnMoreItemsResponse.data.data.learnMoreItems);
		setPages(learnMoreItemsResponse.data.data.pages);
		setActualPage(page);
	};

	const handleSearchBar = () => {
		const load = async () => {
			setLoaded(false);
			await loadItems(1, searchText);
			setLoaded(true);
		};
		load();
	};

	const handleDelete = async (itemDelete) => {
		Swal.fire({
			title: `Tem certeza que deseja excluir o vídeo ${itemDelete.title}?`,
			text: "Não será possível voltar atrás!",
			type: "warning",
			showCancelButton: true,
			confirmButtonColor: "#3085d6",
			cancelButtonColor: "#d33",
			confirmButtonText: "Sim, quero excluir!",
			cancelButtonText: "Cancelar",
		}).then(async (result) => {
			if (!result.value) {
				Swal.fire(
					"Cancelado!",
					"Nenhum dado será excluído.",
					"success",
				);
			} else {
				setLoaded(false);

				try {
					const responseDelete = await api.delete(
						`/learn-more/${itemDelete._id}`,
					);

					if (responseDelete.status === 204) {
						await loadItems(1, searchText);
						setLoaded(true);
					} else {
						throw "Error";
					}
				} catch (error) {
					setLoaded(true);
					Swal.fire({
						type: "error",
						title: "Oops...",
						text: "Tivemos um problema ao excluir esse vídeo do aprenda mais. Contate o suporte!",
					});
				}
			}
		});
	};

	return (
		<Layout
			menuActive="registers"
			pageTitle="Aprenda Mais"
			enableSearchBar={true}
			searchTerm={searchText}
			searchOnChange={(e) => setSearchText(e.target.value)}
			handleSearch={handleSearchBar}
		>
			<div className="row">
				<div className="col-xs-12">
					<div className="card">
						<div className="card-header">
							<div className="card-title">Aprenda Mais</div>
							<ul className="card-action">
								<li>
									<Link
										to="/aprenda-mais/novo"
										className="btn btn-sm btn-success"
									>
										Novo <i className="fa fa-plus"></i>
									</Link>
								</li>
							</ul>
						</div>
						<div
							className={`card-body ${loaded ? "" : "__loading"}`}
						>
							<div className="loader-container text-center">
								<div className="icon">
									<div className="sk-wave">
										<div className="sk-rect sk-rect1"></div>
										<div className="sk-rect sk-rect2"></div>
										<div className="sk-rect sk-rect3"></div>
										<div className="sk-rect sk-rect4"></div>
										<div className="sk-rect sk-rect5"></div>
									</div>
								</div>
								<div className="title">Carregando</div>
							</div>

							<div className="row">
								<div className="col-xs-12">
									<table className="table table-striped table-bordered table-hover">
										<thead>
											<tr>
												<th>Título</th>
												<th>Descrição</th>
												<th>Imagem Capa</th>
												<th>Vídeo</th>
												<th>Opções</th>
											</tr>
										</thead>
										<tbody>
											{learnMoreItems.map(
												(learnMoreItem, index) => {
													return (
														<tr key={index}>
															<td>
																{
																	learnMoreItem.title
																}
															</td>
															<td>
																{
																	learnMoreItem.description
																}
															</td>
															<td>
																<img
																	src={
																		learnMoreItem.coverImageUrl
																	}
																	className="img-responsive"
																/>
															</td>
															<td>
																<video
																	width="480"
																	height="320"
																	controls
																	key={
																		learnMoreItem.videoUrl
																	}
																>
																	<source
																		src={
																			learnMoreItem.videoUrl
																		}
																	/>
																</video>
															</td>
															<td>
																<div className="col-xs-12">
																	<div className="col-xs-12">
																		<Link
																			className="btn btn-xs btn-warning"
																			style={{
																				width: "100%",
																			}}
																			to={`/aprenda-mais/editar/${learnMoreItem._id}`}
																		>
																			Editar
																			Apenas
																			o
																			Texto{" "}
																			<div className="icon fa fa-pencil-square-o"></div>
																		</Link>
																	</div>
																</div>
																<div className="col-xs-12">
																	<div className="col-xs-12">
																		<Link
																			className="btn btn-xs btn-warning"
																			style={{
																				width: "100%",
																			}}
																			to={`/aprenda-mais/editar/${learnMoreItem._id}/com-upload`}
																		>
																			Trocar
																			Foto
																			e
																			Vídeo{" "}
																			<div className="icon fa fa-pencil-square-o"></div>
																		</Link>
																	</div>
																</div>
																{learnMoreItem.active ? (
																	<div className="col-xs-12">
																		<div className="col-xs-12">
																			<button
																				className="btn btn-xs btn-danger"
																				style={{
																					width: "100%",
																				}}
																				onClick={() =>
																					handleDelete(
																						learnMoreItem,
																					)
																				}
																			>
																				Apagar{" "}
																				<div className="icon fa fa-trash"></div>
																			</button>
																		</div>
																	</div>
																) : null}
															</td>
														</tr>
													);
												},
											)}
										</tbody>
									</table>
								</div>
							</div>
							{pages !== 0 ? (
								<div className="row">
									<div className="col-xs-12">
										<ul className="pagination">
											{Array(pages)
												.fill()
												.map((_, page) => (
													<li
														className={
															page + 1 ===
															actualPage
																? "active"
																: ""
														}
													>
														<a
															href="#"
															onClick={(e) => {
																e.preventDefault();
																loadItems(
																	page + 1,
																	searchText,
																);
															}}
														>
															{page + 1}
														</a>
													</li>
												))}
										</ul>
									</div>
								</div>
							) : null}
						</div>
					</div>
				</div>
			</div>
		</Layout>
	);
};

export default withRouter(LearnMoreList);
